import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseWebsocketService } from './base-websocket.service';

interface ReceiptMessage {
  MessageSid: string;
  Body: string;
  NumMedia?: string | number;
  NumSegments?: string | number;
  [key: string]: string | number | undefined;
}

export interface OptStatusChange {
  type: 'opt_status_change';
  phone_number: string;
  isOptedOut: boolean;
}

@Injectable({ providedIn: 'root' })
export class ReceiptWebsocketService extends BaseWebsocketService<ReceiptMessage> {
  protected readonly wsEndpoint = 'messages';
  protected readonly serviceName = 'ReceiptWebsocketService';

  messages$ = this.messagesSubject.asObservable();

  private optStatusSubject = new Subject<OptStatusChange>();
  optStatus$ = this.optStatusSubject.asObservable();

  constructor() {
    super([]);
  }

  protected handleMessage(event: MessageEvent): void {
    console.log('New Message received on Receipt WebSocket:', event.data);
    const parsed = JSON.parse(event.data);
    if (parsed.type === 'opt_status_change') {
      this.zone.run(() => {
        this.optStatusSubject.next(parsed as OptStatusChange);
      });
      return;
    }
    const message = parsed as ReceiptMessage;
    this.zone.run(() => {
      this.messagesSubject.next([message]);
    });
  }
}
